<template>
  <div class="image-block" :style="block.style">
    <div class="image-container">
      <img
        v-if="block.data.src"
        :src="block.data.src"
        :alt="block.data.alt"
        class="image-preview"
      />
      <div v-else class="image-placeholder">
        🖼️ Clique para adicionar imagem
      </div>
    </div>
    <input
      v-if="block.data.src"
      :value="block.data.caption"
      @input="updateCaption"
      placeholder="Legenda da imagem..."
      class="image-caption"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  block: any;
  pageIndex: number;
  blockIndex: number;
}>();

const emit = defineEmits<{
  update: [data: any];
  contentEdit: [];
}>();

function updateCaption(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update", { caption: target.value });
  emit("contentEdit");
}
</script>

<style scoped>
.image-block {
  text-align: center;
}

.image-container {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #007bff;
  }
}

.image-preview {
  max-width: 100%;
  max-height: 300px;
  border-radius: 4px;
}

.image-placeholder {
  color: #6c757d;
  font-size: 14px;
}

.image-caption {
  width: 100%;
  border: 1px dashed #ccc;
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
  font-style: italic;
  color: #666;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
}
</style>
